module.exports = __webpack_public_path__ + "img/guijiimg.50b506fa.png";